import { render, staticRenderFns } from "./inDevelopment.vue?vue&type=template&id=66432bbf&scoped=true&"
import script from "./inDevelopment.vue?vue&type=script&lang=js&"
export * from "./inDevelopment.vue?vue&type=script&lang=js&"
import style0 from "./inDevelopment.vue?vue&type=style&index=0&id=66432bbf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66432bbf",
  null
  
)

export default component.exports